import script from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseSearchInput.vue?vue&type=style&index=0&id=476e3e58&lang=scss&scoped=true"
script.__scopeId = "data-v-476e3e58"

export default script